export class SegmentsDetails {
	SegmentId: number;
	SegmentName: string;
	ExpiryDate: Date;
}